// src/scripts/newsletter.ts
import { subscribeNewsletter } from '../lib/api';

function qs<T extends HTMLElement>(sel: string) {
  return (typeof document !== 'undefined' ? document.querySelector(sel) : null) as T | null;
}

function showToast(message: string, type: 'success' | 'error' = 'success') {
  const toast = qs<HTMLDivElement>('#toast');
  const text = qs<HTMLSpanElement>('#toast-text');
  if (!toast || !text) return;
  text.textContent = message;
  toast.classList.remove('hidden', 'opacity-0', 'translate-y-2', 'bg-green-600', 'bg-red-600');
  toast.classList.add(type === 'success' ? 'bg-green-600' : 'bg-red-600');
  requestAnimationFrame(() => {
    void toast.offsetWidth;
    toast.classList.add('transition-all', 'duration-300');
    toast.classList.remove('opacity-0', 'translate-y-2');
  });
  window.setTimeout(() => {
    toast.classList.add('opacity-0', 'translate-y-2');
    window.setTimeout(() => toast.classList.add('hidden'), 300);
  }, 2500);
}

function setupNewsletterForm() {
  const form = qs<HTMLFormElement>('#newsletter-form');
  const emailInput = qs<HTMLInputElement>('#newsletter-email');
  if (!form || !emailInput) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!form.reportValidity()) return;

    const email = emailInput.value.trim();
    if (!email) return;

    const submitBtn = form.querySelector<HTMLButtonElement>('button[type="submit"]');
    const original = submitBtn?.textContent;
    submitBtn?.setAttribute('disabled', 'true');
    if (submitBtn) submitBtn.textContent = 'Enviando…';

    const payload = {
      email,
      reason: 0,
      name: '',
      phone: '',
      company: '',
      message: '',
    };

    try {
      await subscribeNewsletter(payload); // ← usa BASE correcta
      showToast('¡Gracias! Te has suscrito a la newsletter.', 'success');
      form.reset();
    } catch (err) {
      console.error(err);
      showToast('No se pudo suscribir. Intenta de nuevo.', 'error');
    } finally {
      submitBtn?.removeAttribute('disabled');
      if (submitBtn && original != null) submitBtn.textContent = original;
    }
  });
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  window.addEventListener('DOMContentLoaded', setupNewsletterForm);
}
